import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const NotifDropBox = ({list,setNewnotif}) => {
  useEffect(() => {
    setNewnotif(false)
  }, [])
  
  return (
    <div className='NotifDropBox'>
    <div className='NotifDropBox--headerbox'>
        
      {
        list.slice(0,4).map(
          i=><div>
            {i.subject}
            <hr className='my-4'/>
          </div>
        )
      }
        </div>
       <div className='center NotifDropBox--foot'>
       <Link to='/user/notification'>مشاهده ی همه ی اعلانات</Link>
       </div>
        </div>
  )
}

export default NotifDropBox